import React, { Component }  from 'react';
import { NavLink } from 'react-router-dom';

import constants from '../../helpers/constants'

import AOS from 'aos';
import 'aos/dist/aos.css';


class Products extends Component {
    constructor(props) {
        super(props)
        this.state = {
            url: [],
            isLoaded: false,
            categories:[]
        }
        AOS.init({
            once: true
        });
        document.addEventListener('scroll', function (e) {
            AOS.init({
                once: true,
            });
        });


        this.url = `${constants.urls.API}/getCategories`;
    }

    componentDidMount() {
        fetch(this.url, {
            method: `GET`
        }).then( res =>{
            return res.json()
        })
            .then( result =>{
                this.setState({
                    isLoaded: true,
                    categories: result.category
                })
            })
            .catch( err =>{
                console.log(err);
            })
    }

    render() {
        //console.log( this.state.categories )
        const categories = this.state.categories.map(( item, i ) => (

            <div key={i} className="col-lg-6 col-12 products--page__categories__col">
                <div className="products--page__categories__content products--page__categories__content--industries">
                    <div data-aos="fade-right" data-aos-duration="1000" className="full--height">
                        {item.name != 'Pipes & Fittings' ?
                            <NavLink to={`/products/${item.id}`} exact>
                                <h1 className=" page--title products--page__categories__content__title">
                                    {item.name.indexOf(" ") !== -1 ?
                                        <span className="page--title__main">
                                        {item.name.substring(0, item.name.indexOf(" "))}{`
                                        `}
                                            <span>{item.name.substring(item.name.indexOf(" ") + 1)}</span>
                                    </span>
                                        : item.name
                                    }
                                </h1>
                                <hr className="page--title__line products--page__categories__content__line products--page__categories__content--industries__line"/>
                                <p className="text--content products--page__categories__content__text">
                                    {item.description}
                                </p>
                            </NavLink>
                            :
                            <a target='_blank' href={`http://tahweelpipe.com/en/`} >
                                <h1 className=" page--title products--page__categories__content__title">
                                    {item.name.indexOf(" ") !== -1 ?
                                        <span className="page--title__main">
                                        {item.name.substring(0, item.name.indexOf(" "))}{`
                                        `}
                                            <span>{item.name.substring(item.name.indexOf(" ") + 1)}</span>
                                    </span>
                                        : item.name
                                    }
                                </h1>
                                <hr className="page--title__line products--page__categories__content__line products--page__categories__content--industries__line"/>
                                <p className="text--content products--page__categories__content__text">
                                    {item.description}
                                </p>
                            </a>
                        }
                    </div>
                </div>
            </div>
        ))
        if (!this.state.isLoaded) {
            return <div className="loader">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        }
    return(
        <div className="products--page overflow--hidden">
            <div className="container container--medium products--page__categories">
                <div className="row">
                    { categories }
                </div>
            </div>
        </div>

    )
    // }

}}
export default Products ;
